import { RDEventIrrigation } from '@cibo/core'
import { EventDetailEditorSimple } from '../EventDetail'
import { DetailEditorPropsByYear } from '../types'
import { IrrigationEventEditorSimple } from './IrrigationEventEditorSimple'

export const EventIrrigationEditorSimple = ({
  fieldModels,
  year,
  name = 'eventIrrigation',
  requirement,
  filterInputs,
  traitId,
}: DetailEditorPropsByYear) => (
  <EventDetailEditorSimple<RDEventIrrigation['input']>
    traitId={traitId}
    fieldModels={fieldModels}
    year={year}
    name={name}
    requirement={requirement}
    filterInputs={filterInputs}
    EventComponent={IrrigationEventEditorSimple}
    translationContext="eventIrrigation"
    defaultEvent={{ startDate: null, endDate: null, amount: '', unit: '' }}
  />
)
